import { render, staticRenderFns } from "./VelorailBooking.vue?vue&type=template&id=10667646&"
import script from "./VelorailBooking.vue?vue&type=script&lang=js&"
export * from "./VelorailBooking.vue?vue&type=script&lang=js&"
import style0 from "./VelorailBooking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports